<div
  class="header h-[55px] flex justify-between items-center p-[50px] !bg-[#DEE2E6] sticky z-50 top-0"
>
  <div class="flex items-center">
    <p class="!m-0">{{labels.title}}</p>
    <p
      class="!mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] px-[13px] !h-[24px]"
    >
      Required Documentation
    </p>
  </div>
  <div>
    <mat-icon class="cursor-pointer" (click)="closeModalEvent.emit()"
      >close</mat-icon
    >
  </div>
</div>
<form class="!mt-[30px]" [formGroup]="form">
  <p class="subTitle pl-[28px] pb-[14px]">Technical Submission:</p>
  <div class="!px-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2">
    <span class="label"> Technical Proposal</span>
    <app-rich-textEditor
      (contentChange)="setTechnicalProposal($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('technical_proposal_control')?.value"
    ></app-rich-textEditor>
    <div>
      <app-file-manager
        [newFileControlName]="'technicalProposalFileControl'"
        [oldFiles]="oldTechnicalProposalFiles"
        (newFilesUpdatedEvent)="handleNewFiles($event)"
        (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
      ></app-file-manager>
    </div>

    <span class="label"> Project Programme</span>
    <app-rich-textEditor
      (contentChange)="setProjectProgramme($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('project_programme_control')?.value"
    ></app-rich-textEditor>
    <div>
      <app-file-manager
        [newFileControlName]="'projectProgrammeFileControl'"
        [oldFiles]="oldProjectProgrammeFiles"
        (newFilesUpdatedEvent)="handleNewFiles($event)"
        (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
      ></app-file-manager>
    </div>

    <span class="label"> CVs of Key Personnel</span>
    <div>
      <app-file-manager
        [newFileControlName]="'cvsOfKeyPersonalFileControl'"
        [oldFiles]="oldCvsOfKeyPersonnelFiles"
        (newFilesUpdatedEvent)="handleNewFiles($event)"
        (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
      ></app-file-manager>
    </div>

    <span class="label mt-[14px]"> Relevant Experience</span>
    <span class="sub_label"> Relevant Experience 1</span>
    <div class="flex justify-between items-center w-[100%] gap-16">
      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Client Name:  </mat-label>
          <input
            matInput
            type="text"
            formControlName="client_name_control1"
            placeholder="Client Name"
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('client_name_control1').invalid &&
            form.get('client_name_control1').touched
          "
          class=""
        >
          <span style="color: red">Client name is required</span>
        </div>
      </div>

      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Location </mat-label>
          <input
            matInput
            type="text"
            formControlName="location_control1"
            placeholder="Location "
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('location_control1').invalid &&
            form.get('location_control1').touched
          "
          class=""
        >
          <span style="color: red">Location is required</span>
        </div>
      </div>
    </div>
    <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Project Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="project_description_control1"
          placeholder="Project Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('project_description_control1').invalid &&
          form.get('project_description_control1').touched
        "
      >
        <span style="color: red">Project description is required</span>
      </div>
    </div>

    <span class="sub_label !mt-[53px]"> Relevant Experience 2</span>
    <div class="flex justify-between items-center w-[100%] gap-16">
      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Client Name:  </mat-label>
          <input
            matInput
            type="text"
            formControlName="client_name_control2"
            placeholder="Client Name"
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('client_name_control2').invalid &&
            form.get('client_name_control2').touched
          "
          class=""
        >
          <span style="color: red">Client name is required</span>
        </div>
      </div>

      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Location </mat-label>
          <input
            matInput
            type="text"
            formControlName="location_control2"
            placeholder="Location "
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('location_control2').invalid &&
            form.get('location_control2').touched
          "
          class=""
        >
          <span style="color: red">Location is required</span>
        </div>
      </div>
    </div>
    <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Project Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="project_description_control2"
          placeholder="Project Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('project_description_control2').invalid &&
          form.get('project_description_control2').touched
        "
      >
        <span style="color: red">Project description is required</span>
      </div>
    </div>

    <span class="sub_label !mt-[53px]"> Relevant Experience 3</span>
    <div class="flex justify-between items-center w-[100%] gap-16">
      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Client Name:  </mat-label>
          <input
            matInput
            type="text"
            formControlName="client_name_control3"
            placeholder="Client Name"
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('client_name_control3').invalid &&
            form.get('client_name_control3').touched
          "
          class=""
        >
          <span style="color: red">Client name is required</span>
        </div>
      </div>

      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Location </mat-label>
          <input
            matInput
            type="text"
            formControlName="location_control3"
            placeholder="Location "
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('location_control3').invalid &&
            form.get('location_control3').touched
          "
          class=""
        >
          <span style="color: red">Location is required</span>
        </div>
      </div>
    </div>
    <div class="rounded p-0 !pb-0 !pt-0 w-[100%] min-h-[12vh]">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Project Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="project_description_control3"
          placeholder="Project Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('project_description_control3').invalid &&
          form.get('project_description_control3').touched
        "
      >
        <span style="color: red">Project description is required</span>
      </div>
      <div class="mt-[50px]">
        <app-file-manager
          [newFileControlName]="'relevantExperienceFileControl'"
          [oldFiles]="oldRelevantExperienceFiles"
          (newFilesUpdatedEvent)="handleNewFiles($event)"
          (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
        ></app-file-manager>
      </div>
    </div>
  

    <span class="label !mt-[53px]"> Health & Safety Management Plan</span>
    <app-rich-textEditor
      (contentChange)="setHealthSafety($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('health_safety_control')?.value"
    ></app-rich-textEditor>
    <div>
      <app-file-manager
        [newFileControlName]="'technicalHealthSafetyFileControl'"
        [oldFiles]="oldTechnicalHealthSafetyFiles"
        (newFilesUpdatedEvent)="handleNewFiles($event)"
        (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
      ></app-file-manager>
    </div>
    <span class="label">Environmental Sustainability Plan</span>
    <div class="rounded !pl-0 !pb-0 !pt-0">
      <div
        class="long-section !pl-[21px] !p-10 !pb-0 !pt-0 items-center !w-[100%] !h-[100px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
      >
        <label> Do you have any environmental sustainability plan? </label>
        <mat-radio-group
          formControlName="environmental_sustainability_control"
          aria-label="environmental sustainability"
          class="flex gap-4 justify-end mr-8"
        >
          <mat-radio-button [value]="1">Yes</mat-radio-button>
          <mat-radio-button [value]="0">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <!-- Show Description if 'Yes' is selected -->
    <div
      *ngIf="form.get('environmental_sustainability_control')?.value === 1"
      class="rounded p-0 !pb-0 !pt-0 w-[100%] mt-[8px]"
    >
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="environmental_sustainability_description"
          placeholder="Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('environmental_sustainability_description')?.invalid &&
          form.get('environmental_sustainability_description')?.touched
        "
      >
        <span style="color: red">Description is required</span>
      </div>
      <div *ngIf="form.get('environmental_sustainability_control')?.value === 1" class="mt-[50px]">
        <app-file-manager
          [newFileControlName]="'environmentalSustainabilityPlanFileControl'"
          [oldFiles]="oldEnvironmentalSustainabilityPlanFiles"
          (newFilesUpdatedEvent)="handleNewFiles($event)"
          (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
        ></app-file-manager>
      </div>
    </div>
    

    <!-- Technical Deviations -->
    <span class="label mt-[52px]">Technical Deviations/Clarifications</span>
    <div class="rounded !pl-0 !pb-0 !pt-0">
      <div
        class="long-section !pl-[21px] !p-10 !pb-0 !pt-0 items-center !w-[100%] !h-[100px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
      >
        <label> Do you have any technical deviations? </label>
        <mat-radio-group
          formControlName="technical_deviations_control"
          aria-label="technical deviations"
          class="flex gap-4 justify-end mr-8"
        >
          <mat-radio-button [value]="1">Yes</mat-radio-button>
          <mat-radio-button [value]="0">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <!-- Show Description if 'Yes' is selected -->
    <div
      *ngIf="form.get('technical_deviations_control')?.value === 1"
      class="rounded p-0 !pb-0 !pt-0 w-[100%] mt-[8px]"
    >
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="technical_deviations_description"
          placeholder="Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('technical_deviations_description')?.invalid &&
          form.get('technical_deviations_description')?.touched
        "
      >
        <span style="color: red">Description is required</span>
      </div>
    </div>
    <div *ngIf="form.get('technical_deviations_control')?.value === 1" class="mt-[40px]">
      <app-file-manager
          [newFileControlName]="'technicalDeviationsClarificationsFileControl'"
          [oldFiles]="oldTechnicalDeviationsClarificationsFiles"
          (newFilesUpdatedEvent)="handleNewFiles($event)"
          (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
        ></app-file-manager>
      </div>
  </div>
  
  <div
    class="!pr-[32px] !mb-[30px] !mt-[93px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="handleBack()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px] !mr-[9px]"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
</form>
